import { useMutation, useQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../common/utils/routes';
import { storage } from '../../../common/utils/storage';
import api from '../../apiServices';
import { UserDTO } from '../../types/apiType';
import { showNotification } from '../common/CommonSlice';
import { setUser } from './UserSlice';

export interface CheckSecondPasswordParams {
  password: string;
}

export interface ChangePasswordParams {
  oldPassword: string;
  password: string;
  confirmationPassword?: string;
  code?: string;
}

export const useMyDetailQuery = () => {
  const dispatch = useDispatch();
  const getMyDetail = async () => {
    const res: UserDTO = await api.user.getMyDetail();
    return res;
  };
  return useQuery({
    queryKey: ['user/getMyDetail'],
    queryFn: () => getMyDetail(),
    initialData: null,
    onSuccess: (res) => {
      dispatch(setUser(res));
    },
    onError: (error) => {
      const message = get(error, 'response.data.message');
      if (message) {
        dispatch(showNotification({ message, type: 'error' }));
      }
      localStorage.removeItem('persist:root');
      storage.removeToken();
      setTimeout(() => window.location.reload(), 1000);
    },
  });
};

export const useCheckSecondPasswordMutation = () => {
  const dispatch = useDispatch();

  const checkPassword = async (value: CheckSecondPasswordParams) => {
    const res: string = await api.user.checkSecondPassword(value);
    return res;
  };
  return useMutation({
    mutationFn: checkPassword,
    onError: (error) => {
      const message = get(error, 'response.data.message');
      if (message) {
        dispatch(showNotification({ message, type: 'error' }));
      }
    },
  });
};

export const useChangePasswordMutation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const changePassword = async (value: ChangePasswordParams) => {
    const res: string = await api.user.changePassword(value);
    return res;
  };
  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      dispatch(showNotification({ message: 'Đổi mật khẩu thàng công', type: 'success' }));
      navigate(routes.DEFAULT);
    },
    onError: (error) => {
      const message = get(error, 'response.data.message');
      if (message) {
        dispatch(showNotification({ message, type: 'error' }));
      }
    },
  });
};

export const useSendOtpMutation = () => {
  const dispatch = useDispatch();

  const requestOtp = async () => {
    const res: string = await api.user.requestOtp();
    return res;
  };

  return useMutation({
    mutationFn: requestOtp,
    onSuccess: () => {
      dispatch(showNotification({ message: 'Mã xác nhận có hiệu lực trong 2 phút đã được gửi vào email của bạn.', type: 'success' }));
    },
    onError: (error) => {
      const message = get(error, 'response.data.message');
      if (message) {
        dispatch(showNotification({ message, type: 'error' }));
      }
    },
  });
};

export const useChangeSecondPasswordMutation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const changeSecondPassword = async (value: ChangePasswordParams) => {
    const res: string = await api.user.changeSecondPassword(value);
    return res;
  };

  return useMutation({
    mutationFn: changeSecondPassword,
    onSuccess: () => {
      dispatch(showNotification({ message: 'Đổi mật khẩu cấp 2 thàng công', type: 'success' }));
      navigate(routes.DEFAULT);
    },
    onError: (error) => {
      const message = get(error, 'response.data.message');
      if (message) {
        dispatch(showNotification({ message, type: 'error' }));
      }
    },
  });
};
